export default () => {
    const loader = document.querySelector("#loader-container");
    if (loader) {
        loader.remove();
    }
};
